/* eslint-disable @typescript-eslint/no-explicit-any */
import { setCookieCSR } from '@/app/api/CSR/setCookieCSR'
import { DEFAULT_TOKEN_STORE_DAYS } from '@/utils/constants'
import { ApolloClient } from '@apollo/client'
import {
  signIn as mutation,
  customerLoggedIn as query,
} from '@mercadoni/sinister/dist/cjs/shared/services'
import { setStore } from '@mercadoni/sinister/dist/cjs/shared/utils'
import { DeadpoolUser } from '~types/index'

export const logInDeadpool = async (
  accessToken: string,
  client: ApolloClient<any>,
  clientId: string | null,
  onComplete: (customer: DeadpoolUser) => void,
  logOut: () => void
) => {
  try {
    const response = await client.mutate({
      mutation,
      variables: {
        clientId,
        accessToken,
      },
    })

    const {
      data: {
        signIn: { customer, token },
      },
    } = response
    if (token) {
      setStore('token', token, DEFAULT_TOKEN_STORE_DAYS, false)
      setCookieCSR(`_IL-token`, token, DEFAULT_TOKEN_STORE_DAYS)
      onComplete(customer)
    }
  } catch (error) {
    console.log('login error:', error)
    logOut()
    return false
  }
}

export const relogInDeadpool = async (
  client: ApolloClient<any>,
  onComplete: (customer: DeadpoolUser) => void
) => {
  const response = await client.query({
    query,
    fetchPolicy: 'no-cache',
  })
  const {
    data: { customerLoggedIn },
  } = response
  if (customerLoggedIn?.id) {
    onComplete(customerLoggedIn)
  }
}
